// Alma ERP — القائمة الجانبية: مجموعات قابلة للطي (تُحفظ حالتها محليًا)، عناصر حسب الأقسام الممنوحة والدور، وبطاقة المستخدم في الأسفل.
import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { NAV, ROLE_LABEL } from "../nav";

const LS_KEY = "alma.sidebar.open";
const load = () => { try { return JSON.parse(localStorage.getItem(LS_KEY) || "{}"); } catch (_) { return {}; } };

export default function Sidebar({ onClose }) {
  const { user, logout, isAdmin, canSee, refresh } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(load);
  const [busy, setBusy] = useState(false);
  useEffect(() => { try { localStorage.setItem(LS_KEY, JSON.stringify(open)); } catch (_) { /* */ } }, [open]);

  const groups = NAV.map((g) => ({ ...g, items: g.items.filter((it) => (it.admin || g.admin ? isAdmin : canSee(it.key))) })).filter((g) => g.items.length);
  const isOpen = (g) => (open[g.key] === undefined ? true : open[g.key]) || g.items.some((it) => pathname.startsWith(it.path));
  const toggle = (k) => setOpen((o) => ({ ...o, [k]: !(o[k] === undefined ? true : o[k]) }));
  const doRefresh = async () => { setBusy(true); try { await refresh(); toast.success("حُدّثت الصلاحيات"); } catch (_) { toast.error("تعذّر التحديث"); } setBusy(false); };
  const initials = (user?.display_name || user?.email || "?").trim().charAt(0).toUpperCase();

  return (
    <aside className="sb">
      <div className="sb-head">
        <img src="/logo-colored.svg" alt="" onError={(e) => { e.currentTarget.style.display = "none"; }} />
        <div><div className="t">ألما المالية — نظام الإدارة</div><div className="s">Alma Capital ERP</div></div>
        <button type="button" className="sb-close" onClick={onClose} aria-label="إغلاق">✕</button>
      </div>
      <nav className="sb-nav">
        {groups.map((g) => (
          <div key={g.key} className={`sb-group${isOpen(g) ? " open" : ""}`}>
            <button type="button" className="sb-group-btn" onClick={() => toggle(g.key)}><span className="ic">{g.icon}</span><span>{g.label}</span><span className="chev">◀</span></button>
            <div className="sb-items">
              {g.items.map((it) => <NavLink key={it.key} to={it.path} className={({ isActive }) => `sb-item${isActive ? " active" : ""}`} onClick={onClose}><span className="ic">{it.icon}</span><span>{it.label}</span></NavLink>)}
            </div>
          </div>
        ))}
        {!groups.length && <div style={{ color: "#94a3b8", fontSize: 12.5, padding: 14, lineHeight: 1.7 }}>لم تُمنح لك أي أقسام بعد. اطلب من مدير النظام تفعيل الأقسام المطلوبة.</div>}
      </nav>
      <div className="sb-foot">
        <div className="sb-user">
          {user?.avatar_url ? <img src={user.avatar_url} alt="" /> : <div className="av">{initials}</div>}
          <div style={{ minWidth: 0 }}><div className="n" title={user?.email}>{user?.display_name || user?.email}</div><div className="r">{ROLE_LABEL[user?.role] || user?.role}</div></div>
        </div>
        <button type="button" className="sb-btn" disabled={busy} onClick={doRefresh}>↻ تحديث الصلاحيات</button>
        <button type="button" className="sb-btn danger" onClick={logout}>⎋ خروج</button>
      </div>
    </aside>
  );
}
